import state from '../MapState/state'

export default {
  setDefaultGraphYear (state: {[key:string]: string}, year: string) {
    state.defaultGraphYear = year
  },
  setDefaultGraphSeason (state: {[key:string]: string}, season: string) {
    state.defaultGraphSeason = season
  }
}
